import { useEffect } from 'react';
import useGoogleMapsApi from './useGoogleMapsApi';

/**
 * Returns an instance of google autocomplete service
 */
const useGooglePlaces = (
  places: any,
  options?: google.maps.places.AutocompleteOptions,
  callBackFn?: () => void
) => {
  const google = useGoogleMapsApi(
    process.env.REACT_APP_GOOGLE_MAPS_RETAIL_TOKEN ?? ''
  );

  useEffect(() => {
    if (!google) {
      return;
    }

    const autoComplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      options
    );

    autoComplete.addListener('place_changed', callBackFn);
    places.current = autoComplete;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [google]);
};

export default useGooglePlaces;
